import draftToHtml from 'draftjs-to-html'

const getEmailSig = ({ formData }) =>
  `<br /><br />---<br /><br />${formData.first_name} ${formData.last_name}<br />${formData.address}<br />${formData.postcode}<br />`

export const getSubmitProps = ({ action, formData, token }) => {
  switch (action) {
    case 'email':
      return {
        postRoute: 'api/email',
        postData: {
          email: {
            subject: formData.subject,
            body: draftToHtml(JSON.parse(formData.body)) + getEmailSig({ formData }),
          },
          signup: _.pick(formData, [
            'first_name',
            'last_name',
            'email',
            'address',
            'postcode',
            'opt_in',
          ]),
          token,
        },
      }
    case 'signup':
      return {
        postRoute: 'api/signup',
        postData: {
          signup: _.pick(formData, [
            'first_name',
            'last_name',
            'postcode',
            'email',
            'address',
            'opt_in',
          ]),
        },
      }
  }
}
